import { render } from "./SupportMeasures.vue?vue&type=template&id=5e8f9bff&scoped=true"
import script from "./SupportMeasures.vue?vue&type=script&lang=js"
export * from "./SupportMeasures.vue?vue&type=script&lang=js"

import "./SupportMeasures.vue?vue&type=style&index=0&id=5e8f9bff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8f9bff"]])

export default __exports__